module.exports = __webpack_public_path__ + "assets/724c81a0c8cd7857a0feecb682aa8e06.png";